import React from "react"

interface BookingsViewProps {
  bookings: any[]
  onClose: () => void
}

export function BookingsView({ bookings, onClose }: BookingsViewProps) {
  return (
    <div style={{ padding: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h3 style={{ fontSize: "18px", fontWeight: "600", margin: 0 }}>My Bookings</h3>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: "#6b7280",
          }}
        >
          ×
        </button>
      </div>

      {bookings.length === 0 ? (
        <div style={{ textAlign: "center", padding: "32px", color: "#6b7280" }}>
          <p>No bookings found</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {bookings.map((booking) => (
            <div
              key={booking._id}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "12px",
                backgroundColor: "#f9fafb",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "8px" }}>
                <h4 style={{ fontSize: "16px", fontWeight: "600", margin: 0 }}>
                  {booking.serviceName}
                </h4>
                <span
                  style={{
                    padding: "2px 8px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    backgroundColor: booking.status === "confirmed" ? "#dcfce7" : "#fef3c7",
                    color: booking.status === "confirmed" ? "#166534" : "#92400e",
                  }}
                >
                  {booking.status}
                </span>
              </div>
              
              <div style={{ fontSize: "14px", color: "#6b7280", marginBottom: "4px" }}>
                📅 {new Date(booking.date).toLocaleDateString()} at {booking.time}
              </div>
              
              {booking.notes && (
                <div style={{ fontSize: "14px", color: "#6b7280" }}>
                  📝 {booking.notes}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}